export default __webpack_public_path__ + "static/media/profilePlaceholder.43106d77.svg";